import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom";

const useAppHooks = () => {
  const dispatch = useDispatch();
  const selector = useSelector;

  // router v5 hooks
  const history = useHistory();
  const location = useLocation();
  const params = useParams();
  const match = useRouteMatch();

  return {
    dispatch,
    selector,
    history,
    location,
    params,
    match,
  };
};

export default useAppHooks;
